import React, { useEffect, useState } from "react";
import { Upload, message, Typography, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import axios from "axios";
import "./fileUpload.scss";
import UploadFileImg from "../../../assets/images/uploadFile.png";
import { toast } from "react-toastify";

const { Dragger } = Upload;

const FileUpload = ({
  uploadUrl = `${process.env.REACT_APP_API_URI}/common/upload`,
  maxFileSize = 1,
  accept = ".png,.jpeg,.jpg",
  label,
  label2,
  maxFileSizeText,
  setFieldValue,
  initialPreview,
}) => {
  const [fileList, setFileList] = useState(
    initialPreview
      ? [{ uid: "-1", name: "Uploaded Image", url: initialPreview }]
      : []
  );
  const [previewImage, setPreviewImage] = useState(initialPreview || null);

  useEffect(() => {
    if (initialPreview) {
      setPreviewImage(initialPreview);
      setFileList([{ uid: "-1", name: "Uploaded Image", url: initialPreview }]);
    }
  }, [initialPreview]);

  // Validate file before upload
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    const isLtSize = file.size / 1024 / 1024 < maxFileSize;

    if (!isImage) {
      toast.error("Only image files are allowed!");
      return Upload.LIST_IGNORE;
    }
    if (!isLtSize) {
      toast.error(`File must be smaller than ${maxFileSize}MB!`);
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  // Handle file upload
  const handleUpload = async ({ file }) => {
    const formData = new FormData();
    formData.append("file", file);

    const token = localStorage.getItem("ACCESS_TOKEN");
    try {
      const response = await axios.post(uploadUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-api-key": process.env.REACT_APP_API_KEY,
          authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.code === 200) {
        const imageUrl = response.data?.result?.rows?.[0]?.image_url;
        if (imageUrl) {
          const fullUrl = `${process.env.REACT_APP_API_IMG_URI}/${imageUrl}`;
          setFieldValue(imageUrl);
          setFileList([{ uid: file.uid, name: file.name, url: fullUrl }]);
          setPreviewImage(fullUrl);
          message.success("File uploaded successfully!");
        } else {
          message.error("Upload successful, but no image URL received!");
        }
      } else {
        message.error("Failed to upload file!");
      }
    } catch (error) {
      message.error("Error uploading file!");
    }
  };

  // Handle file removal
  const handleRemove = () => {
    setFileList([]);
    setPreviewImage(null);
    setFieldValue("");
  };

  return (
    <div className="uploadFile">
      <Dragger
        customRequest={handleUpload}
        fileList={fileList}
        beforeUpload={beforeUpload}
        accept={accept}
        maxCount={1}
        showUploadList={true}
        className="customDragger"
      >
        <>
          <p className="label2">{label2}</p>
          <img src={UploadFileImg} alt="Upload" />
          <p className="dragDrop">
            Drag & drop or <span> Choose file</span>
          </p>
          <Typography.Text
            type="secondary"
            style={{ fontSize: 12, marginTop: 4 }}
          >
            {maxFileSizeText}
          </Typography.Text>
        </>
      </Dragger>

      {previewImage && (
        <div className="image-preview">
          <img
            src={previewImage}
            alt="Preview"
            style={{
              width: "120px",
              height: "120px",
              objectFit: "cover",
              borderRadius: "8px",
              marginTop: "10px",
              border: "1px solid #d9d9d9",
            }}
          />
          <Button
            icon={<CloseOutlined />}
            type="text"
            onClick={handleRemove}
            style={{ marginLeft: "10px", color: "red" }}
          >
            Remove
          </Button>
        </div>
      )}
    </div>
  );
};

export default FileUpload;
